import { useState } from 'react';
import { Eye, EyeOff, LockKeyhole, ShieldCheck, UserRound } from 'lucide-react';
import { hasSupabaseConfig } from '../../lib/supabase';
import { signInRadar } from '../../services/auth';
import './login.css';

type Props = { onDemoLogin?: () => void };

export function LoginPage({ onDemoLogin }: Props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError('');
    if (!hasSupabaseConfig) {
      onDemoLogin?.();
      return;
    }
    setLoading(true);
    try {
      const { error: signInError } = await signInRadar(username, password);
      if (signInError) throw signInError;
    } catch {
      setError('Usuário ou senha inválidos. Verifique os dados informados.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login-page">
      <div className="login-overlay" />
      <section className="login-panel" aria-label="Acesso ao Radar SAEB">
        <header className="login-identity">
          <img src="/assets/prefeitura-tres-lagoas.png" className="city-logo" alt="Prefeitura de Três Lagoas" />
          <img src="/assets/radar-saeb-logo.svg" className="radar-logo" alt="Radar SAEB Simulados" />
        </header>
        <div className="divider" />
        <form className="login-form" onSubmit={submit}>
          <div className="login-heading">
            <span className="eyebrow">ACESSO INSTITUCIONAL</span>
            <h1>Bem-vindo(a)!</h1>
            <p>Entre com seu usuário e senha para acessar o sistema.</p>
          </div>
          <label>Usuário<div className="field"><UserRound size={20}/><input value={username} onChange={e=>setUsername(e.target.value)} autoComplete="username" placeholder="Digite seu usuário" required autoFocus /></div></label>
          <label>Senha<div className="field"><LockKeyhole size={20}/><input value={password} onChange={e=>setPassword(e.target.value)} type={showPassword?'text':'password'} autoComplete="current-password" placeholder="Digite sua senha" required/><button type="button" className="eye" onClick={()=>setShowPassword(v=>!v)} aria-label={showPassword?'Ocultar senha':'Mostrar senha'}>{showPassword?<EyeOff size={19}/>:<Eye size={19}/>}</button></div></label>
          {error && <div className="login-error" role="alert">{error}</div>}
          <button className="primary" disabled={loading}>{loading?'Entrando...':'Entrar'}</button>
          {!hasSupabaseConfig && onDemoLogin && <button className="demo" type="button" onClick={onDemoLogin}>Visualizar protótipo</button>}
          <div className="security"><ShieldCheck size={17}/><span>Acesso seguro e restrito aos perfis autorizados.</span></div>
        </form>
      </section>
      <footer className="login-footer">© 2026 Prefeitura de Três Lagoas · Secretaria Municipal de Educação</footer>
    </main>
  );
}
